const getFullAddress = address_json => {
    const {calle, localidad, municipio, estado}  = address_json;
    return `${calle ? calle + ', ' : ''}${localidad ? localidad + ', ' : ''}${municipio ? municipio + ', ' : ''}${estado ? estado + ', ' : ''}`;
}

export default getFullAddress;